module.exports = __webpack_public_path__ + "img/1557614090825834497.050ace4e.png";